import { EVENTS_APP_ID } from './app-definitions';
export var SERVER_BASE_URL = 'https://events.wixapps.net/events-server';
export var LIVE_VIDEO_API_URL = '/_api/livevideo-server';
export var SCHEDULE_API_URL = '/_api/wix-events-schedule';
export var EVENTS_WEB_API_URL = '/_api/wix-events-web';
export var getBillingUrl = function (msid, referral) {
    return "https://www.wix.com/store/plans?v=1&appDefId=" + EVENTS_APP_ID + "&siteGuid=" + msid + (referral ? "&referralAdditionalInfo=" + referral : '') + "#/";
};
//# sourceMappingURL=urls.js.map